import React from 'react';
import {FIND_ALL_MODELO_ANUNCIO as query} from '../../graphql/queries';
import {SelectBase} from './mui-base';

const getVariables = ({pageNumber, search = '', searchDTO = {}, pageSize = 30}) => {
  return {
    pageable: {pageNumber, pageSize, sortField: 'nome', sortDir: 'ASC'},
    searchDTO: {...searchDTO, search, ativo: true},
  };
};

export const SelectModelosAnuncio = (props) => {
  return (
    <SelectBase
      label="Modelo anúncio"
      responseObjectName="findAllModeloAnuncio"
      labelProp="nome"
      getVariables={(searchProps) => getVariables({...searchProps, ...props})}
      query={query}
      {...props}
    />
  );
};
